module.exports = __webpack_public_path__ + "img/jidian_bg.01d182d9.png";